import { Component } from '@angular/core';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { AuthService } from 'src/app/services/auth.service';
import { RedimirEnfermera } from 'src/app/models/redimir.interface';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
import { Paginar } from 'src/app/models/http-paginacion.interface';
@Component({
  selector: 'app-enfermera-canjes',
  templateUrl: './enfermera-canjes.component.html',
  styleUrls: ['./enfermera-canjes.component.scss'],

})
export class EnfermeraCanjesComponent {
  enfermera!: Enfermera;
  canjes!: RedimirEnfermera[];
  estatus: string[] = [...DESCRIPCION_STATUS_CANJE];

  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 10;

  constructor(private enfermeraService: EnfermeraService, private authService: AuthService) {

    if (this.authService.isLoggedIn) {
      const idEnfermera: number | undefined = this.authService.getUsuario?.enfermera?.id;
      if (idEnfermera) this.obtenerInformacion(idEnfermera);
    }

  }

  get totalPaginas(): number {
    return Math.ceil(this.canjes.length / this.currentPage.rows);
  }
  get paginacionCanjesEnfermeras(): RedimirEnfermera[] {
    const startIndex = (this.currentPage.page) * this.currentPage.rows;
    return this.canjes.slice(startIndex, startIndex + this.currentPage.rows);
  }

  obtenerInformacion(id: number): void {
    this.enfermeraService.getEnfermera(id).subscribe({
      next: (resp) => {
        this.enfermera = resp.datos;
        this.canjes = resp.datos.canjes;
        this.totalItems = resp.datos.canjes.length;

        //  console.log(resp)
      },
      error: (err) => console.log(err)
    });
  }
  getDescripcion(id: number): string {
    return this.estatus[id];
  }
  onPageChange(event: any) {
    this.currentPage = <Paginar>event;
  }
}
